import { useMemo } from "react";

import LocationReason from "api/types/models/location_reason";
import { FormGroup, Label, Multiselect, Select, SelectOption } from "@mwi/ui";

type ReasonsTabProps = {
  watch: any;
  errors: any;
  control: any;
  reasons: LocationReason[] | undefined;
};

const ReasonsTab = ({ watch, errors, control, reasons }: ReasonsTabProps) => {
  const conditionOptions = useMemo(
    () => [
      { id: "does_work_with", name: "Only works with" },
      { id: "doesnt_work_with", name: "Doesn't work with" },
    ],
    [],
  );

  return (
    <div className="flex flex-col gap-y-[18px] mb-20">
      <FormGroup error={errors?.reason_condition?.works_with}>
        <Label className="!text-sm">Condition</Label>
        <Select
          control={control}
          placeholder="Select condition"
          name="reasons_condition.works_with"
        >
          {conditionOptions?.map((condition) => (
            <SelectOption key={condition.id} value={condition.id}>
              {condition.name}
            </SelectOption>
          ))}
        </Select>
      </FormGroup>
      <FormGroup error={errors?.reasons_condition?.reasons}>
        <Label className="!text-sm">Reasons</Label>
        <Multiselect
          control={control}
          placeholder="Select exceptions"
          name="reasons_condition.reasons"
          optionsContainerClassName="max-h-[190px]"
          disabled={!watch("reasons_condition.works_with")}
        >
          {reasons?.map((s) => (
            <Multiselect.Option key={s.id} value={s.id}>
              {s.name}
            </Multiselect.Option>
          ))}
        </Multiselect>
      </FormGroup>
    </div>
  );
};

export default ReasonsTab;
